import React, { useEffect, useState } from "react";
import VersionHistoryBtn from "../../../components/buttons/versionHistoryBtn";
import "../../../modules/superUsers/superUsers.css";
import back from "../../../assets/back.svg";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import CreateBtn from "../../../components/buttons/createBtn";
import InputField from "../../../components/form/inputField/inputField";
import { NavLink, useNavigate } from "react-router-dom";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import ErrorMsg from "../../../components/form/errorMsg";
import { useDispatch } from "react-redux";
import { fetchDivisionList } from "../../../redux/actions/commonActions";
import {
  createSuperUserRole,
  permissionsRoleList,
} from "../../../redux/actions/superUserAction";
// import { vendorDivisionList } from "../../../redux/actions/productActions";
import CreatedPopUp from "../../../components/popups/CreatedPopUp";
import InputCapitalField from "../../../components/form/inputField/inputCapitalField";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const SuperUserRoleCreate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [permission, setPermission] = useState([]);
  const [settingId, setSettingID] = useState(null);
  const [created, setCreated] = useState(false);
  const [approvalLevel, setApprovalLevel] = useState("");

  const phoneRegex = /^([+]\d{2})?\d{10}$/;

  useEffect(() => {
    dispatch(permissionsRoleList(fetchPermissionSuccess, fetchPermissionError));
  }, []);

  const fetchPermissionSuccess = (data) => {
    setPermission(data);
  };

  const fetchPermissionError = (data) => {
    console.log(data);
  };

  const initialValues = {
    role_name: "",
    role_level: "",
    permissions: [],
  };

  const validationSchema = Yup.object().shape({
    role_name: Yup.string().required("Required"),
    role_level: Yup.string().required("Required"),
    permissions: Yup.array()
      .min(1, "At least one should be selected")
      .required("Required"),
  });

  const clearFunc = (setFieldValue) => {
    setFieldValue("role_name", "");
    setFieldValue("role_level", "");
    setFieldValue("permissions", []);
  };

  const onSubmit = (values) => {
    console.log(values);
    dispatch(createSuperUserRole(values, onSuccess, onError));
  };
  const onSuccess = (data) => {
    console.log(data);
    setCreated(true);
    const timeOutFnc = () => {
      setCreated(false);
      navigate("/super-user/role");
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  const selectPermission = (e, index, setFieldValue, access, values) => {
    let newArr = values.permissions;
    const i = newArr.findIndex((ex) => ex.id == index);
    if (access == "read") {
      if (i > -1)
        newArr[i] = {
          id: index,
          read: !newArr[i].read,
          write: newArr[i].write,
        };
      else newArr.push({ id: index, read: true, write: false });
    } else if (access == "write") {
      if (i > -1)
        newArr[i] = {
          id: index,
          read: !newArr[i].write,
          write: !newArr[i].write,
        };
      else newArr.push({ id: index, read: true, write: true });
    }
    setFieldValue("permissions", newArr);
  };

  const options = [
    { value: "L1", label: "Level 1" },
    { value: "L2", label: "Level 2" },
    { value: "L3", label: "Level 3" },
  ];

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/super-user/role",
      breadcrumb: " / super users / role",
    },
    {
      path: "/super-user/role/create",
      breadcrumb: " / create",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ setFieldValue, values }) => (
              <Form className="">
                <div className="search-container d-flex justify-content-between align-items-center">
                  <div
                    className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                    onClick={() => navigate(-1)}
                  >
                    <img src={back} alt="back_btn" />
                    <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                      BACK
                    </span>
                  </div>
                  <div className=" d-flex justify-content-between m-1 mb-2">
                    <AdminButton
                      background="#E7E5FF"
                      width="100px"
                      type="button"
                      onClick={() => clearFunc(setFieldValue)}
                    >
                      CLEAR
                    </AdminButton>
                    <AdminButton
                      background="#7065e4"
                      color="white"
                      width="100px"
                      type="submit"
                    >
                      <span className="m-2">SAVE</span>
                    </AdminButton>
                  </div>
                </div>
                <div className="scrolling">
                  <div className="form-width ms-4 ps-3 py-1">
                    <div className="my-4">
                      <InputCapitalField
                        setFieldValue={setFieldValue}
                        id={"role_name"}
                        label={"Role Name"}
                        labelColor={"color_262c3d"}
                        type={"text"}
                        placeholder={"Enter role name"}
                        name={"role_name"}
                        value={values?.role_name}
                      />
                    </div>
                    <div className="my-2">
                      <label className="color_262c3d fw_400 fs_14">
                        Levels
                      </label>
                      <Field>
                        {({ form, Field }) => (
                          <Select
                            options={options}
                            styles={customStyles}
                            {...Field}
                            placeholder={"Select level"}
                            id="role_level"
                            value={options.filter(
                              (c) => c.value == values?.role_level
                            )}
                            onChange={(selectedOption) => {
                              form.setFieldValue(
                                "role_level",
                                selectedOption.value
                              );
                              setApprovalLevel(selectedOption.value);
                            }}
                          />
                        )}
                      </Field>
                      <ErrorMsg name="role_level" />
                    </div>
                    <div className="my-0">
                      <label className=" color_262c3d fs_14">Permission</label>
                    </div>
                    <div className="my-1 d-flex  label-container align-items-center justify-content-start ">
                      <div className="col-5">
                        <label className="color_b0b3c7 fs_14">Models</label>
                      </div>
                      <label className="color_b0b3c7 fs_14 ms-4 ps-2">
                        Read
                      </label>
                      <label className="color_b0b3c7 fs_14 ms-4 ps-2">
                        Write
                      </label>
                    </div>
                    {permission?.map((ele, index) => (
                      <div
                        className="d-flex my-1 label-container align-items-center justify-content-start"
                        key={index}
                      >
                        <div className="col-6">
                          <label className="fs_14">{ele.label}</label>
                        </div>
                        <div>
                          <span className="fs_14 my-1">
                            <input
                              type={"checkbox"}
                              className="superCheck"
                              checked={values?.permissions?.some(
                                (ex) => ex.id === ele?.id && ex.read
                              )}
                              onChange={(e) => {
                                console.log();
                                selectPermission(
                                  e,
                                  ele?.id,
                                  setFieldValue,
                                  "read",
                                  values
                                );
                              }}
                              disabled={values?.permissions?.some(
                                (ex) => ex.id === ele?.id && ex.write
                              )}
                            />
                          </span>
                        </div>
                        <div className="ms-5">
                          <span className="fs_14 my-1">
                            <input
                              type={"checkbox"}
                              className="superCheck"
                              onChange={(e) => {
                                selectPermission(
                                  e,
                                  ele?.id,
                                  setFieldValue,
                                  "write",
                                  values
                                );
                              }}
                            />
                          </span>
                        </div>
                      </div>
                    ))}
                    <ErrorMsg name={"permissions"} />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <CreatedPopUp
            show={created}
            handelClose={() => setCreated(false)}
            title={"Role Created Successfully"}
          />
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default SuperUserRoleCreate;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",

    borderRadius: "5px",
    width: "100%",

    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
};
